import { httpClient } from '@/api/httpClient';
import type { LegalDocumentCode } from '@/constants/legal';
import {
  mapApiResourceToLegalDocument,
  type LegalDocument,
  type LegalDocumentApiResource,
  type LegalDocumentReference,
  type PendingLegalDocumentsApiResource,
} from './legalApi.types';

export async function fetchLegalDocument(code: LegalDocumentCode): Promise<LegalDocument> {
  const response = await httpClient.get<LegalDocumentApiResource>('/public/legal/' + code);
  return mapApiResourceToLegalDocument(response.data);
}

export async function fetchPendingLegalDocuments(): Promise<LegalDocumentReference[]> {
  const response = await httpClient.get<PendingLegalDocumentsApiResource>('/me/legal/pending');
  return response.data.documents;
}

export async function acceptLegalDocuments(documents: LegalDocumentReference[]): Promise<void> {
  await httpClient.post('/me/legal/accept', { documents });
}
